module.exports = __webpack_public_path__ + "img/gestao.8a8ddd01.png";